<div class="box">
  <div class="header">
    <div class="content" [ngClass]="'greendAnalityco' || 'primary'">{{'REFERENCIAS DE TIPOS DE HORAS EXTRAS' || 'N/A'}}</div>
  </div>

  <div class="content-card list-card">
    <form [formGroup]="configReferencesTypesOvertimeForm">
      <div class="grid" formArrayName="items">
        <div class="row" *ngFor="let grp of items.controls; let i = index" [formGroupName]="i">
          <span class="label" [attr.id]="'lbl-code-'+i">
          {{ grp.get('label')?.value }}
        </span>

          <mat-form-field appearance="outline" class="code-field">
            <mat-label class="sr-only">{{ grp.get('label')?.value }}</mat-label>

            <input
              matInput
              formControlName="code"
              maxlength="10"
              inputmode="latin"
              autocomplete="off"
              spellcheck="false"
              class="code-input"
              [attr.aria-labelledby]="'lbl-code-'+i"
              (input)="onCodeInput(i)" />

            <mat-error *ngIf="grp.get('code')?.hasError('required')">Requerido</mat-error>
            <mat-error *ngIf="grp.get('code')?.hasError('pattern')">Solo letras y números (máx. 10)</mat-error>
            <mat-error *ngIf="grp.get('code')?.hasError('maxlength')">Máximo 10 caracteres</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div class="btn-actions">
    <button mat-button class="btn-cancelar" (click)="close()">CANCELAR</button>&nbsp;&nbsp;
    <button mat-button class="btn-generar" (click)="save()">GUARDAR</button>
  </div>
</div>
